module.exports = __webpack_public_path__ + "media/images/icons/twitter-8d08575fedf3aada686668658eb0ff6e.svg";